import {useContext} from 'react';
import {AbilityContext} from '.';
import {AbilityContextType} from './types';

const useAbility = () => useContext(AbilityContext) as AbilityContextType;
export default useAbility;
